class ModalVideo {
    static init() {
        this.uid = 'video-embed';
        this.modalUid = 'modal-container';
        const modalDiv = document.createElement('div');
        modalDiv.id = this.modalUid;
        document.body.appendChild(modalDiv);

        document.querySelectorAll('.watch-video').forEach(element => {
            element.addEventListener('click', (event) => {
                event.preventDefault();
                this.setVideoSource(event.currentTarget);
                this.launchModal(true);
            });
        });
    }

    static setVideoSource(element) {
        this.item = element;
        this.videoID = this.item.getAttribute('data-source');
        this.type = this.item.getAttribute('data-type');
    }

    static launchModal(autoplay) {
        this.setTop();
        document.getElementById(this.modalUid).innerHTML = this.modalHTML();
        document.body.classList.add('modal-open', 'modal-video-open');
        this.pauseAllPlayingVideos();

        if (this.type === 'youtube') {
            this.setupYoutube(autoplay);
        }

        if (this.type === 'vimeo') {
            this.setupVimeo(autoplay);
        }

        if (this.type === 'wistia') {
            this.setupWistia(autoplay);
        }

        this.setupCloseEvent();
    }

    static setupYoutube(autoplay) {
        return new YT.Player(this.uid, {
            width: '100%',
            height: '100%',
            videoId: this.videoID,
            playerVars: {
                autoplay: autoplay ? 1 : 0
            }
        });
    }

    static setupVimeo(autoplay) {
        return new Vimeo.Player(this.uid, {
            id: this.videoID,
            width: '100%',
            muted: false,
            playsinline: true,
            autoplay: autoplay
        });
    }

    static setupWistia(autoplay) {
        window._wq = window._wq || [];
        _wq.push({
            id: this.videoID,
            options: {
                autoPlay: autoplay,
                controlsVisibleOnLoad: true,
                endVideoBehavior: 'default',
                playerColor: '#f25a54',
            }
        });
    }

    static setupCloseEvent() {
        document.querySelectorAll('.modal .close').forEach(element => {
            element.addEventListener('click', (event) => {
                event.preventDefault();
                document.body.classList.remove('modal-open', 'modal-video-open');
                document.getElementById(this.modalUid).innerHTML = '';
                this.resetTop();
            });
        });
    }

    static modalHTML() {
        let videoContainer;
        switch (this.type) {
            case 'upload':
                videoContainer = `
                    <video autoplay controls>
                        <source id='mp4' src="${this.videoID}" type='video/mp4' />
                    </video>
                `;
                break;

            case 'wistia':
                videoContainer = `<div class="wistia_embed wistia_async_${this.videoID}"></div>`;
                break;

            default:
                videoContainer = `<div id="${this.uid}"></div>`;
                break;
        }

        return `
            <div class="modal in" id="modal-video">
                <div class="modal-content">
                    <div class="video-wrap">
                        <div class="bg-modal close"></div>
                        <div class="video-frame with-background">
                            <a href="#" class="modal-close close"></a>
                            <div class="video">
                                ${videoContainer}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    static setTop() {
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        document.body.style.top = `-${scrollY}px`;
        document.documentElement.style.setProperty('--scroll-y', `${scrollY}px`);
    }

    static resetTop() {
        const scrollY = parseInt(document.body.style.top || '0') * -1;
        document.body.style.top = '';
        window.scrollTo(0, scrollY);
    }

    static pauseAllPlayingVideos() {
        const videos = document.querySelectorAll('video.video-stop-on-modal')
        const playingVideos = Array.from(videos).filter(video => !video.paused && !video.ended);
        playingVideos.forEach(video => video.pause());
    }
}

export default ModalVideo
